export default __webpack_public_path__ + "static/polygon2-1502108da6be060110c94a99c2da602d.png";